import React from 'react';
import { Check, X } from 'lucide-react';

interface PasswordStrengthProps {
  password_?: string;
}

interface RequirementProps {
  label: string;
  met: boolean;
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthProps> = ({
  password_ = '',
}) => {
  const checks = {
    length: password_.length >= 8,
    uppercase: /[A-Z]/.test(password_),
    lowercase: /[a-z]/.test(password_),
    number: /\d/.test(password_),
  };

  const strength = Object.values(checks).filter(Boolean).length;
  const strengthPercentage = (strength / 4) * 100;

  const getStrengthColor = () => {
    if (strength <= 2) return 'bg-red-500';
    if (strength === 3) return 'bg-yellow';
    return 'bg-green'; // strength === 4
  };

  const Requirement: React.FC<RequirementProps> = ({ label, met }) => (
    <li
      className={`flex items-center text-sm ${
        met ? 'text-green-dark' : 'text-gray-500'
      }`}
    >
      {met ? (
        <Check className="mr-2 h-4 w-4" />
      ) : (
        <X className="mr-2 h-4 w-4" />
      )}
      {label}
    </li>
  );

  return (
    <div className="space-y-4">
      <div className="h-2 w-full rounded-full bg-gray-200">
        <div
          className={`h-2 rounded-full ${getStrengthColor()}`}
          style={{ width: `${strengthPercentage}%` }}
        ></div>
      </div>
      <ul className="space-y-2">
        <Requirement label="Au moins 8 caractères" met={checks.length} />
        <Requirement label="Une lettre majuscule" met={checks.uppercase} />
        <Requirement label="Une lettre minuscule" met={checks.lowercase} />
        <Requirement label="Un chiffre" met={checks.number} />
      </ul>
    </div>
  );
};

export default PasswordStrengthIndicator;
